import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  // Positioning context for the absolutely-placed expand button.
  wrapper: {
    position: 'relative',
    width: '100%',
  },

  textareaRoot: {
    width: '100%',
  },

  // Reserve room at the top-right so the expand button doesn't overlap text.
  inlineTextarea: {
    paddingRight: '34px',
  },

  expandButton: {
    position: 'absolute',
    top: tokens.spacingVerticalXXS,
    right: tokens.spacingHorizontalXXS,
    zIndex: 1,
  },

  // Large editor inside the maximize dialog.
  dialogTextareaRoot: {
    width: '100%',
    height: '70vh',
  },

  dialogTextarea: {
    height: '100%',
    maxHeight: '100%',
  },
});
